// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Spinner/Basic.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Spinner, view, css} from '@sail/ui';

export const Basic = () => (
  <view.div
    css={{
      width: css.value('300px'),
      background: 'surface',
      padding: 'medium',
      borderRadius: 'large',
      layout: 'column',
      textAlign: 'center',
    }}
  >
    <Spinner size="small" />
    <Spinner />
    <Spinner size="large" />
  </view.div>
);
